export enum ApiError {
  GET_QUIZ_CONTENT_ERROR = "Не удалось получить данные опросника",
  SEND_LEAD_ERROR = "Не удалось отправить заявку",
  UPDATE_LEAD_ERROR = "Не удалось отправить данные",
  UNKNOWN_ERROR = "Неизвестная ошибка"
}